import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { responseObj } from '../../nest-model/nest-model';
import { NestApiProvider } from '../../nest-api';

@Injectable()
export class EducationSf6Provider {

  module: string = '';
  model: string = 'sf6s/education';

  constructor(
    public http: HttpClient,
    public nestApi: NestApiProvider
  ) {
    console.log('Hello Education SF6 Provider');
  }

  add(formData) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "add";
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  save(formData) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "save";
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }

  delete(formData) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "delete";
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-integrated/services/education-sf6.ts